import { createFileRoute, redirect } from '@tanstack/react-router';

/** Old URL kept working after the Content navigation was regrouped — redirects to /content/settings/instructions. */
export const Route = createFileRoute('/_authenticated/_tenant/content/prompts')({
  beforeLoad: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/content/settings/instructions', replace: true });
  },
});
